import {Component, OnInit} from "@angular/core";
import {HeaderService} from "../../services/header.service";
import {ApiService} from "../../services/api.service";
import {Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {SelectionService} from "../../services/selection.service";
import {UserService} from "../../services/user.service";

@Component({
  selector: "app-workplace-selection",
  templateUrl: "./workplace-selection.component.html",
  styleUrls: ["./workplace-selection.component.scss"],
})
export class WorkplaceSelectionComponent implements OnInit {
  constructor(
    private header: HeaderService,
    private apiService: ApiService,
    public userService: UserService,
    private router: Router,
    private cookieService: CookieService,
    private selectionService: SelectionService
  ) {
    this.selectedProductionLineUuid =
      this.cookieService.get("productionLine").split("%")[0] || "";
    this.selectedWorkplaceUuid =
      this.cookieService.get("workplace").split("%")[0] || "";
  }

  panelOpenState = false;
  public selectedProductionLineUuid: string;
  public selectedProductionLine: string;
  public selectedWorkplaceUuid: string;
  public selectedWorkplace: string;
  public selectedProductionLineIndex: number | null;
  public selectedWorkplaceIndex: number | null;
  productionLines: any = [];
  workplaces: any = [];
  isSelected: boolean = true;

  ngOnInit(): void {
    // if(this.getCookie('productionLine') && this.getCookie('workplace')) {
    //   this.router.navigate(['/dashboard']);
    // }

    this.header.setBackgroundColor("#ffffff");
    this.header.setHeaderTitle("");
    this.header.setHeaderSubTitle("Produktionsbereich / Arbeitsplatz Auswahl");
    this.header.setHeaderIcon("bi bi-door-open");
    this.header.setIsHeaderClickable(false);

    this.apiService.getProductionLines().then((res) => {
      this.productionLines = res.data;
    });
  }

  getCookie(name: string) {
    return this.cookieService.get(name);
  }

  setCookie(name: string, value: string) {
    this.cookieService.set(name, value, {expires: 365});
  }

  loadWorkplaces() {
    this.apiService
      .getWorkplacesByProductionLine(this.selectedProductionLineUuid)
      .then((res) => {
        this.workplaces = res.data;
      });
  }

  selectProductionLine(id: string, name: string, index: number) {
    this.selectedProductionLineIndex = index;
    this.selectedWorkplaceUuid = "";
    this.selectedWorkplaceIndex = null;

    this.selectedProductionLineUuid = id;
    this.selectedProductionLine = name;

    this.loadWorkplaces();
  }

  selectWorkplace(id: string, name: string, index: number) {
    this.selectedWorkplaceUuid = id;
    this.selectedWorkplace = name;
    this.selectedWorkplaceIndex = index;
  }

  toggleIsSelected() {
    this.isSelected = !this.isSelected;
  }

  toDashboard() {
    if (this.selectedProductionLine && this.selectedWorkplace) {
      this.setCookie(
        "productionLine",
        `${this.selectedProductionLineUuid}%${this.selectedProductionLine}`
      );
      this.setCookie(
        "workplace",
        `${this.selectedWorkplaceUuid}%${this.selectedWorkplace}`
      );
      this.selectionService.changeWorkplace(this.selectedWorkplaceUuid);
      this.selectionService.changeProductionLine(
        this.selectedProductionLineUuid
      );
      this.router.navigate(["/dashboard"]);
    } else {
      alert("Bitte Produktionslinie und Arbeitsplatz auswählen");
    }
  }
}
